import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ITransferListModel, ITransferListRequestModel, IVoidTransferRequestModel } from '@app/interfaces';
@Injectable({
	providedIn: 'root',
})
export class TransferTransHistoryService {
	constructor(private readonly http: HttpClient) {}
	endpoint = '/api/transfers';

	public getTransferHistory(request: ITransferListRequestModel): Observable<ITransferListModel[]> {
		return this.http.post<ITransferListModel[]>(`${this.endpoint}/list`, request);
	}

	public createTransferEntries(request: ITransferListModel): Observable<any> {
		return this.http.post(`${this.endpoint}/create`, request);
	}

	public voidTransferEntries(request: IVoidTransferRequestModel): Observable<any> {
		return this.http.post(`${this.endpoint}/void`, request);
	}

	public queueTransfersReport(paramModel: ITransferListRequestModel): Observable<any> {
		return this.http.post(`${this.endpoint}/queue-transfers-report`, paramModel);
	}
}
